import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem, RepositoryModal, SchedulingTask } from '../../shared'
import { SchedulingComponent } from './scheduling.component'

@Component({
    templateUrl: './scheduling-task.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class SchedulingTaskComponent extends RepositoryModal<SchedulingTask> {
    jobMap: ListItem<string>[] = []
    boolMap: ListItem<boolean>[] = [new ListItem(true, 'Yes'), new ListItem(false, 'No')]
    departmentMap: ListItem<number>[] = []
    schedulingComponent!: SchedulingComponent

    protected onInitialized() {
        this.schedulingComponent = this.editOptions.initializeParams as SchedulingComponent

        this.jobMap = this.services.data.schedulingJobs.items.map(x => new ListItem(x.job, x.jobName))
        this.departmentMap = this.schedulingComponent.departmentOptions.map(x => new ListItem(x.id, x.value))

        if (this.isAdding) {
            this.target.priority = 20
            this.target.phasePriority = 20
            this.target.departmentId = this.schedulingComponent.activeTab
            this.target.siteReady = false
            this.target.materialsReady = false
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.job) this.target.job = this.jobMap[0].value
        return true
    }
}
